import AdminForm from "features/admin/AdminForm";
import { FieldsRow } from "features/admin/Products/types";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  addPromo,
  fetchPromoOptions,
  selectPromoOptions,
} from "../promoAdminSlice";
// const fields: FieldsRow[] = [
//   {
//     row: [
//       {
//         title: "Изберете вид промоция",
//         data: [
//           {
//             required: false,
//             type: "select",
//             title: "Тип",
//             name: "type",
//             options: [
//               "Инвертор",
//               "Хиперинвертор",
//               "Подов",
//               "Колонен",
//               "Мултисплит",
//               "Таванен",
//               "Канален",
//               "Касетъчен",
//               "VRV",
//             ],
//             value: "",
//           },
//           {
//             type: "select",
//             title: "Марка",
//             name: "brand",
//             required: false,
//             options: [
//               "Fuji Electric",
//               "Fujitsu General",
//               "Daikin",
//               "Mitsubishi Electric",
//               "Mitsubishi Heavy",
//               "Gree",
//               "Vivax",
//               "LG",
//               "Hitachi",
//               "Toshiba",
//               "Midea",
//               "Panasonic",
//               "National",
//             ],
//             value: "",
//           },

//           {
//             type: "select",
//             title: "Категория",
//             name: "category",
//             required: false,
//             options: [
//               "Нов",
//               "Нов  (Япония)",
//               "Втора употреба  (Япония)",
//               "Втора употреба",
//               "Преоценени",
//             ],
//             value: "",
//           },
//           {
//             type: "select",
//             title: "Мощност BTU",
//             name: "power_btu",
//             required: false,
//             options: [
//               "7 000 BTU",
//               "9 000 BTU",
//               "10 000 BTU",
//               "12 000 BTU",
//               "13 000 BTU",
//               "14 000 BTU",
//               "15 000 BTU",
//               "16 000 BTU",
//               "18 000 BTU",
//               "20 000 BTU",
//               "21 000 BTU",
//               "22 000 BTU",
//               "24 000 BTU",
//               "30 000 BTU",
//             ],
//             value: "",
//           },
//           {
//             type: "select",
//             title: "Квадратура",
//             name: "quadrature",
//             required: false,
//             options: [
//               "от 10 до 15 кв.м.",
//               "от 15 до 20 кв.м.",
//               "от 20 до 25 кв.м.",
//               "от 25 до 30 кв.м.",
//               "от 30 до 35 кв.м.",
//               "от 35 до 40 кв.м.",
//               "от 40 до 45 кв.м.",
//               "от 45 до 50 кв.м.",
//               "от 50 до 55 кв.м.",
//               "от 55 до 60 кв.м.",
//               "от 60 до 65 кв.м.",
//               "от 65 до 70 кв.м.",
//               "от 70 до 75 кв.м.",
//             ],
//             value: "",
//           },
//           {
//             type: "select",
//             title: "Енергиен клас охлаждане",
//             name: "energy_class_cooling",
//             required: false,
//             options: ["А", "А+", "А++", "А+++"],
//             value: "",
//           },
//           {
//             type: "select",
//             title: "Енергиен клас отопление",
//             name: "energy_class_heating",
//             required: false,
//             options: ["А", "А+", "А++", "А+++"],
//             value: "",
//           },
//           {
//             required: false,
//             options: undefined,
//             type: "boolean",
//             title: "Всички климатици",
//             name: "all_products",
//             value: false,
//           },
//         ],
//       },
//       {
//         title: "Информация",
//         data: [
//           {
//             required: true,
//             options: undefined,
//             type: "text",
//             title: "Име на промоцията",
//             name: "title",
//             value: "",
//           },

//           {
//             required: false,
//             options: undefined,
//             type: "number",
//             title: "Намаление %",
//             name: "discount_pеrcentage",
//             value: "",
//           },
//           {
//             required: false,
//             options: undefined,
//             type: "number",
//             title: "Намаление в лв",
//             name: "discount_sum",
//             value: "",
//           },
//           {
//             required: false,
//             options: undefined,
//             type: "boolean",
//             title: "Активна",
//             name: "is_active",
//             value: true,
//           },
//         ],
//       },
//     ],
//   },
// ];

const AddPromo = () => {
  const dispatch = useDispatch();
  const [progress, setProgress] = useState(0);
  const fields = useSelector(selectPromoOptions);
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(fetchPromoOptions());
  }, [dispatch]);

  const onSubmit = (data: any) => {
    dispatch(
      addPromo(data, (event) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      })
    );
    navigate(-1);
  };

  return (
    <AdminForm
      formTitle="Добавяне на промоция"
      onSubmit={onSubmit}
      product={fields}
      progress={progress}
    />
  );
};

export default AddPromo;
